import { IOption } from '../../../../../../components/Select/Select';
import { IEventEnrollment } from '../../../../../../store/admin/eventEnrollments/store';

export const getPlayersOptionsFromEnrollments = (enrollments: IEventEnrollment[]) =>
  enrollments.reduce(
    (acc: IOption[], enrollment: IEventEnrollment) => [
      ...acc,
      {
        label: `${enrollment.user.firstName} ${enrollment.user.lastName}`,
        value: String(enrollment.user.id)
      }
    ],
    []
  );
